const $inject = ['$scope', '$routeParams', '$filter', 'hotelTagService', 'dataService'];

const lbaHotelTagSelectCtrl = function ($scope, $routeParams, $filter, hotelTagService, dataService) {
  const vm = this;
  const dataLookUp = dataService.spiltDataAt(vm.settings.dataAt, $routeParams);

  vm.data = _.get(dataService.data.activeItem, dataLookUp);
  vm.tags = hotelTagService.get().map(tag => {
    return tag.Name
  });

  $scope.$watchCollection('vm.data', (newData, oldData) => {
    if (newData !== oldData) {
      _.set(dataService.data.activeItem, dataLookUp, newData)
    }
  });
};

lbaHotelTagSelectCtrl.$inject = $inject;

export default lbaHotelTagSelectCtrl;


// WEBPACK FOOTER //
// ./src/components/lbaHotelTagSelect/lbaHotelTagSelectCtrl.js